import { useMemo } from "react";
import { useLocation, useParams } from "react-router";
import { useOptionalProjectInventory } from "../../contexts/projectInventory";
import useSelectionContext from "../useSelectionContext";

const normalizeFilterId = value => {
  if (!value || value === "null" || value === "all") {
    return undefined;
  }

  return value;
};

export const useAssetsFilterVariables = (order, hasImportedAssets) => {
  const projectInventory = useOptionalProjectInventory();
  const location = useLocation();
  const params = useParams();
  const { clientId: persistedClientId } = useSelectionContext();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const clientId = projectInventory
    ? normalizeFilterId(projectInventory.clientId)
    : normalizeFilterId(searchParams.get("clientId")) || normalizeFilterId(persistedClientId);

  const projectId = projectInventory
    ? normalizeFilterId(projectInventory.projectId)
    : normalizeFilterId(params.projectId) || normalizeFilterId(searchParams.get("projectId"));

  return useMemo(() => {
    const variables = {};

    // Always include clientId for subscriptions
    if (clientId) {
      variables.clientId = clientId;
    }

    if (projectId) {
      variables.projectId = projectId;
    }

    if (order) {
      const [key, value] = order.split(".");
      variables.order = { [key]: value };
    }

    if (hasImportedAssets) {
      variables.hasImportedAssets = hasImportedAssets;
    }

    return variables;
  }, [projectId, clientId, order, hasImportedAssets]);
};
